/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreditCardPayInfo
 */
export interface CreditCardPayInfo {
    /**
     * 商户服务ID
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    serviceId?: string;
    /**
     * 支付方式服务代码（信用卡：0900）
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    serviceCode?: string;
    /**
     * 支付类型（普通支付：0000）
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    serviceType?: string;
    /**
     * 商户订单号
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    orderId?: string;
    /**
     * 订单时间（YYYYMMDDHH24MISS）
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    orderDate?: string;
    /**
     * 支付金额
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    amount?: string;
    /**
     * 回调地址
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    returnUrl?: string;
    /**
     * 商品代码
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    itemCode?: string;
    /**
     * 商品名称
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    itemName?: string;
    /**
     * 商户用户ID
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    userId?: string;
    /**
     * 购买者姓名
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    userName?: string;
    /**
     * 购买者邮箱
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    userEmail?: string;
    /**
     * hash_key
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    hashKey?: string;
    /**
     * 支付窗口LOGO
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    logo?: string;
    /**
     * 编码方式
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    charset?: string;
    /**
     * 是否返回取消结果
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    cancelFlag?: string;
    /**
     * WEB-API模式标识
     * @type {string}
     * @memberof CreditCardPayInfo
     */
    webapiFlag?: string;
}

/**
 * Check if a given object implements the CreditCardPayInfo interface.
 */
export function instanceOfCreditCardPayInfo(value: object): value is CreditCardPayInfo {
    return true;
}

export function CreditCardPayInfoFromJSON(json: any): CreditCardPayInfo {
    return CreditCardPayInfoFromJSONTyped(json, false);
}

export function CreditCardPayInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditCardPayInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceId': json['serviceId'] == null ? undefined : json['serviceId'],
        'serviceCode': json['serviceCode'] == null ? undefined : json['serviceCode'],
        'serviceType': json['serviceType'] == null ? undefined : json['serviceType'],
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderDate': json['orderDate'] == null ? undefined : json['orderDate'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'returnUrl': json['returnUrl'] == null ? undefined : json['returnUrl'],
        'itemCode': json['itemCode'] == null ? undefined : json['itemCode'],
        'itemName': json['itemName'] == null ? undefined : json['itemName'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userEmail': json['userEmail'] == null ? undefined : json['userEmail'],
        'hashKey': json['hashKey'] == null ? undefined : json['hashKey'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'charset': json['charset'] == null ? undefined : json['charset'],
        'cancelFlag': json['cancelFlag'] == null ? undefined : json['cancelFlag'],
        'webapiFlag': json['webapiFlag'] == null ? undefined : json['webapiFlag'],
    };
}

export function CreditCardPayInfoToJSON(json: any): CreditCardPayInfo {
    return CreditCardPayInfoToJSONTyped(json, false);
}

export function CreditCardPayInfoToJSONTyped(value?: CreditCardPayInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serviceId': value['serviceId'],
        'serviceCode': value['serviceCode'],
        'serviceType': value['serviceType'],
        'orderId': value['orderId'],
        'orderDate': value['orderDate'],
        'amount': value['amount'],
        'returnUrl': value['returnUrl'],
        'itemCode': value['itemCode'],
        'itemName': value['itemName'],
        'userId': value['userId'],
        'userName': value['userName'],
        'userEmail': value['userEmail'],
        'hashKey': value['hashKey'],
        'logo': value['logo'],
        'charset': value['charset'],
        'cancelFlag': value['cancelFlag'],
        'webapiFlag': value['webapiFlag'],
    };
}

